import { render, staticRenderFns } from "./TheFooter.component.vue?vue&type=template&id=df6a29e4"
import script from "./TheFooter.component.vue?vue&type=script&lang=js"
export * from "./TheFooter.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports